export enum RestRequestType {
  CREATE_COMPONENT = 'create-component-req',
  UPDATE_COMPONENT = 'update-component-req',
  CREATE_TAG = 'create-tag-req',
  CREATE_MODEL = 'create-model-req',
  UPDATE_MODEL = 'update-model-req',
  CREATE_ASSET = 'create-asset-req',
  UPDATE_ASSET = 'update-asset-req',
  REGISTER_NODE = 'register-newNode',
  UPDATE_NODE = 'update-node',
  CREATE_MEASUREMENT = 'create-measurement-req',
  UPDATE_MEASUREMENT = 'update-measurement-req',
  CREATE_UOM = 'create-uom-req',
  UPDATE_UOM = 'update-uom-req',
  CREATE_DATASOURCE = 'create-datasource-req',
  UPDATE_DATASOURCE = 'update-datsource-req',
  CREATE_NODELINK = 'create-nodeLink-req',
  UPDATE_NODELINK = 'update-nodeLink-req',
  CREATE_ASSET_DS_LINK = 'create-assetDsLink-req',
  UPDATE_ASSET_DS_LINK = 'update-assetDsLink-req',
  TRIGGER_REBIRTH = 'node-rebirth-req',
  CREATE_ALARM = 'create-alarm-req',
  UPDATE_ALARM = 'update-alarm-req',
  UPDATE_COMPONENT_INSTANCE = 'update-componentInstance-req',
  CREATE_SUBSCRIPTION = 'create-subscription-req',
  UPDATE_SUBSCRIPTION = 'update-subscription-req',
  CREATE_PERSPECTIVE = 'create-perspective-req',
  UPDATE_PERSPECTIVE = 'update-perspective-req',
  CREATE_PERSPECTIVE_GROUP = 'update-perspectiveGroup-req',
  UPDATE_PERSPECTIVE_GROUP = 'update-perspectiveGroup-req',
  MODE_PERSPECTIVE_NODE = 'move-perspectiveNode-req',
  GET_TAG_VALUES = 'get-tagValues-req',
  Ack_ALARM = 'acknowledged-alarm',
  RESET_ALARM = 'reset-alarm',

  DELETE_ASSET = 'delete-asset-req',
  CREATE_OVERRIDE_PROPERTY = "create-override-property-req",
  UPDATE_OVERRIDE_PROPERTY = "update-override-property-req",
  CREATE_COMPONENT_PANEL = 'create-component-panel',
  UPDATE_COMPONENT_PANEL = 'update-component-panel',
  CREATE_DASHBOARD = 'create-dashboard',
  UPDATE_DASHBOARD = 'update-dashboard',
  TAGS_LIVE_DATA = 'tags-live-data',
  TAGS_LIVE_DATA_SERIES = 'tags-live-data-series',
  WRITE_BACK_REQ = 'write-back-req',
  DEFAULT_PERSPECTIVE = 'set-default-Perspective',
  CREATE_AGGREGATE = 'create-aggregate',
  UPDATE_AGGREGATE = 'update-aggregate',
  GET_AGGREGATES = 'get-aggregates',
  CREATE_USER = 'create-user',
  UPDATE_USER = 'update-user',
  CREATE_ROLE = 'create-role',
  DELETE_ROLE = 'delete-role',
  UPDATE_ROLE = 'update-role',
  CREATE_USER_GROUP = 'create-user-group',
  UPDATE_USER_GROUP = 'update-user-group',
  CREATE_FEATURE = 'create-feature',
  UPDATE_FEATURE = 'update-feature',
  DELETE_FEATURE = 'delete-feature',
  ADD_GROUP_MEMBER = 'add-usergroup-members',
  REMOVE_GROUP_MEMBER = 'remove-usergroup-members',
  FETCH_GQL = 'fetch-gql',
  CREATE_ACLS='create-acls-req',
  UPDATE_ACLS='update-acls-req',
  DELETE_ACLS='delete-acls-req',
  ASSET_EVENTS = 'line-chart-asset-events',
  CREATE_COMPONENT_TYPE ='create-comp-type',
  UPDATE_COMPONENT_TYPE ='update-comp-type-req',
  UPDATE_VENDOR ='update-vendor-req',
  CREATE_MODEL_TYPE ='create-model-type',
  UPDATE_MODEL_TYPE ='update-model-type',
  CREATE_GROUP ='create-group',
  CREATE_QULAITY_CODE = 'create-quality-code-req',
  UPADTE_QULAITY_CODE = 'update-quality-code-req',
  UPDATE_GROUP ='update-group',
  DELETE_GROUP ='delete-group',
  CREATE_VENDOR ='create-vendor',
  RESET_COUNTS_GLOBAL = 'reset-counts-global',
  RESET_COUNT = 'reset-count',
}
